/* eslint-disable react/react-in-jsx-scope */
import { convertM2ToHectares } from "@/libs/utils";
import { CountryLang } from "@/types/pp";
import { useEffect, useState } from "react";
import Actor from "./Actor";
import MapProject from "./MapProject";
import Photo from "./Photo";
import TextInfo from "./TextInfo";

const SummarySheetRight = ({
  project,
  surface,
  carrier,
  manager,
  fundLocal,
}) => {
  const [coordinates, setCoordinates] = useState<{
    lat: number;
    lon: number;
  } | null>(null);
  useEffect(() => {
    const fetchCoordinates = async () => {
      const countryName = project?.country?.countryLang?.find(
        (lang: CountryLang) => lang.lang.code === "fr"
      )?.name;

      if (countryName) {
        try {
          const url = `https://nominatim.openstreetmap.org/search?format=json&q=${countryName}`;
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const dataCountry = await response.json();
          if (dataCountry?.length > 0) {
            const { lat, lon } = dataCountry[0];
            setCoordinates({ lat: parseFloat(lat), lon: parseFloat(lon) });
          }
        } catch (error) {
          console.error("Failed to fetch coordinates:", error);
        }
      }
    };

    fetchCoordinates();
  }, [project]);
  return (
    <div className="p-4">
      <div className="sticky top-0">
        <div className="pb-5 w-full rounded-[20px]">
          <MapProject
            isReadOnly={true}
            projectName={project?.name || ""}
            idProject={project?.id}
          />
        </div>
        <div className="rounded-[20px]  bg-[#F7F9FB] p-4">
          <TextInfo className="" title="Pays" text={project?.country.name} />
          <TextInfo
            className=""
            title="Point GPS(latitude,longitude):"
            text={
              coordinates != undefined
                ? coordinates?.lat + " , " + coordinates?.lon
                : "chargement des coordonnées..."
            }
          />
          <TextInfo
            className=""
            title="Surface utile de(s) parcelle(s) concernées :"
            text={convertM2ToHectares(surface) + " ha"}
          />
        </div>
        <div className="mt-3">
          <TextInfo className="" title="Photos :" text="" />
          <div>
            <Photo project={project} guide={false} />
          </div>
        </div>
        <div className="rounded-[20px]  bg-[#F7F9FB] p-4 mt-3">
          <TextInfo className="" title="Porteur du projet :" text="" />
          <Actor actor={carrier} />
          <div>
            <TextInfo className="" title="Acteurs impliqués : " text="" />
            <Actor actor={manager} fundLocal={fundLocal} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummarySheetRight;
